export const DATA_HOOKS = {
  leaveGroupDialog: 'Leave group dialog',
};
